export type Scalars = {
  DateTime: string; // Date on BE, string on FE
};

export enum MediaStatus {
  Completed = 'COMPLETED',
  Error = 'ERROR',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Removed = 'REMOVED',
  Uploading = 'UPLOADING',
}

// @todo: remove optionals.
export type Media = {
  id: string;
  fileSize?: number | null;
  name?: string | null;
  mediaStatus: MediaStatus;
  vimeoThumbnailUrl?: string | null;
  vimeoUri?: string | null;
  type?: string | null;
  s3Id?: string | null;
  s3OriginId?: string | null;
  s3Region?: string | null;
  url?: string | null;
  transloaditS3Id?: string | null;
};
